
import { formatDistanceToNow } from "date-fns";
const formatRelativeDate = (date) => {
  const now = new Date();
  const target = new Date(date);

  const diffDays = Math.floor(
    (now - target) / (1000 * 60 * 60 * 24)
  );

  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";

  let text = formatDistanceToNow(target, { addSuffix: true });

  // Remove "about", "over", "almost"
  text = text.replace(/^(about|over|almost)\s+/i, "");

  // Capitalize first letter (optional, looks better)
  return text.charAt(0).toUpperCase() + text.slice(1);
};
const RecentJobs = ({ jobs }) => (
   <div className="col-lg-12">
    <div class="card shadow-sm h-100">
              <div class="card-header d-flex justify-content-between align-items-center">
                  <div>
                    <h2 class="h6 mb-0">Recent Job Postings</h2>
                    <small class="text-muted">Latest jobs created by employers</small>
                  </div>
                  <div class="dropdown">
                    <button
                      class="btn btn-sm btn-outline-secondary dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                    >
                      Filter
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li><a class="dropdown-item" href="#">All</a></li>
                      <li><a class="dropdown-item" href="#">Pending</a></li>
                      <li><a class="dropdown-item" href="#">Approved</a></li>
                      <li><a class="dropdown-item" href="#">Rejected</a></li>
                    </ul>
                  </div>
                </div>
                <div class="table-responsive">
                  <table className="jobs-table table align-middle mb-0">
                    <thead>
                      <tr>
                        <th>Job</th>
                        <th>Company</th>
                        <th>Created</th>
                        <th>Status</th>
                        {/* <th>Actions</th> */}
                      </tr>
                    </thead>

                    <tbody>
                      {jobs.map(job => (
                        <tr key={job.job_id}>
                          <td>
                            <div className="fw-semibold">{job.title}</div>
                            <small className="text-muted">{job.job_location}</small>
                          </td>
                          <td>
                            <div className="fw-semibold">{job.company_name}</div>
                          </td>
                          {/* <td>{formatDistanceToNow(new Date(job.created_at), { addSuffix: true })}</td> */}
                          <td>{formatRelativeDate(job.created_at)}</td>
                          <td>
                            <span className={`badge ${job.status.toLowerCase()} border badge-status`}>
                              {job.status}
                            </span>
                          </td>
                          {/* <td>
                            <button className="btn btn-sm btn-outline-secondary">View</button>
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div class="card-footer text-end">
                  {/* <small class="text-muted">
                    Showing 1–10 of 120 recent jobs
                  </small> */}
                  <a href="/admin/jobs" class="small">View all jobs</a>
                </div>
            </div>
    </div>
);

export default RecentJobs;
